/* lua.js generated code 0.3.0 */

var HomeSceneAnimBase = xClass("HomeSceneAnimBase", cc.Node)

HomeSceneAnimBase.prototype.ctor = function () {
    cc.Node.prototype.ctor.call(this)
}
HomeSceneAnimBase.prototype.onEnter = function () {
    cc.Node.prototype.onEnter.call(this)
}
HomeSceneAnimBase.prototype.pause = function () {
    cc.Node.prototype.pause.call(this)
}
HomeSceneAnimBase.prototype.resume = function () {
    cc.Node.prototype.resume.call(this)
}
HomeSceneAnimBase.prototype.onTouched = function () {}
HomeSceneAnimBase.prototype.onTouchUp = function () {}
HomeSceneAnimBase.prototype.setFlipX = function (flip) { }
HomeSceneAnimBase.prototype.cleanup = function () {
    var self = this
    cc.eventManager.removeListener(self.listener)
    cc.Node.prototype.cleanup.call(self)
}
HomeSceneAnimBase.prototype.addClickListner = function () {
    var self = this
    if (self._listened) {
        return 
    }
    self._listened = true
    var ctx = self
    function onTouchesBegan(touch, event) {
        var tp = touch.getLocation()
        var s = self.getContentSize()
        var ap = self.getAnchorPoint()
        var position = self.convertToNodeSpace(tp)
        var touchRect = cc.rect(-s.width * 0.5, -s.height * 0.5, s.width, s.height)
        var b = cc.rectContainsPoint(touchRect, position)
        if (b) {
            ctx.onTouched()
        }
        return b
    }
    function onTouchEnded(touch, event) {
        ctx.onTouchUp()
    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(false)
    listener.registerScriptHandler(onTouchesBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    listener.registerScriptHandler(onTouchEnded, cc.Handler.EVENT_TOUCH_ENDED)
    cc.eventManager.addListener(listener, self)
    self.listener = listener
    // var eventDispatcher = self.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listener, self)
}
module.exports = HomeSceneAnimBase
